import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./Breadcrumbs.scss";
import { MdKeyboardArrowRight } from "react-icons/md";

const Breadcrumbs = ({ currentPageName, to1, mainoption }) => {
  return (
    <div className="breadcrumbs">
      <Fragment>
        <Link to={`/${to1}`} className="breadcrumbs--link">
          {mainoption}
        </Link>
        <MdKeyboardArrowRight className="breadcrumbs--icon" />
      </Fragment>
      <p className="breadcrumbs--p">{currentPageName}</p>
    </div>
  );
};

// We need for props currentPageName because sometimes route is a parameter number or path for product and we need name for it.
// In the future we need change for this bug.
Breadcrumbs.propTypes = {
  currentPageName: PropTypes.object,
};

export default Breadcrumbs;
